// @flow
import * as React from 'react';
import { SidePane } from 'esm-web-pro/components/layout';
import MapSidePaneInfo from 'esm-web-pro/containers/map/sidepane/MapSidePaneInfo';
import MapEditForm from 'esm-web-pro/containers/map/sidepane/MapEditForm';
import Editor from 'esm-web-pro/containers/map/Editor';

type Props = {
    editor: Editor,
    resource: Object,
    formatMessage: Object,
    currLayer: Object,
    showMapEditForm: boolean,
    // eslint-disable-next-line react/no-unused-prop-types
    setShowMapEditForm: Function,
    onClose: Function,
    loading: boolean,
    messages: Object,
};

const MAP_SIDE_CONTAINER_KEY = 'MAP_SIDE_CONTAINER';

const MapSidePaneContainer = (props: Props) => {
    const {
        resource, currLayer, loading, editor, formatMessage, showMapEditForm, messages, onClose,
    } = props;

    if (currLayer && resource) {
        return (
            <SidePane
                id={MAP_SIDE_CONTAINER_KEY}
                key={`${resource.name}-${
                    currLayer.feature.id}`}
                openInitially
            >
                {!showMapEditForm && (
                    <MapSidePaneInfo
                        title={`${formatMessage(resource.label)}
                                                ${currLayer.feature.properties.name}`}
                        onClose={onClose}
                        updatingObject={{
                            resource,
                            layer: currLayer,
                        }}
                        loading={loading}
                        editor={editor}
                        handleDeleteClick={
                            (e) => editor.handleDeleteClick(
                                resource, currLayer, e,
                            )
                        }
                        resource={resource}
                    />
                )}
                {showMapEditForm && (
                    <MapEditForm
                        title={`${formatMessage(
                            messages['update-save'],
                        )} ${
                            typeof resource.label === 'string'
                                ? resource.label
                                : formatMessage(resource.label)
                        }`}
                        updatingObject={{
                            resource,
                            layer: currLayer,
                        }}
                        setIsSubmitting={
                            (isSubmitting) => (
                                editor.setIsSubmitting(isSubmitting)
                            )
                        }
                        handleCreateSave={editor.handleCreateSave}
                        handleEditClose={editor.handleEditClose}
                    />
                )}
            </SidePane>
        );
    }
    return null;
};

export default MapSidePaneContainer;
